module.exports = __webpack_public_path__ + "img/js-calculator.eab74284.png";